module.exports = __webpack_public_path__ + "static/media/arties3.a91513a1.jpg";